import React, {createContext, useContext, useEffect, useState} from 'react';
import {UserAuthService} from "../services/user-auth-api.service";

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
    const [firstLogin, setFirstLogin] = useState(false)
    // const [api, contextHolder] = notification.useNotification();
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark')
    const [sidebarCollapse, setSidebarCollapse] = useState(false)
    const [token, setToken] = useState(localStorage.getItem('RUK_AUTH_TOKEN') ? localStorage.getItem('RUK_AUTH_TOKEN')  : '' );
    const [user, setUser] = useState(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {} );
    const [vaultSearch,setVaultSearch] = useState('')
    const [pointUpdate, setPointUpdate] = useState(false);
    const [chartUpdate, setChartUpdate] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [resetVerified, setResetVerified] = useState(false);
    const [profileUpdate, setProfileUpdate] = useState(false);
    const [chartSelected, setChartSelected] = useState('Weekly');
    const [chartFilterType, setChartFilterType] = useState(10);
    const [isForum, setIsForum] = useState(false);
    const [isCoach, setIsCoach] = useState(false);
    const [selectedYear, setSelectedYear] = useState(2026); // Default year is 2026

    const checkTheme = () => {
        if(theme){
            document.body.setAttribute('data-theme', theme);
        }
    };

    const VaultSearch = (data) =>{
        setVaultSearch(data)
    }

    const checkUser = () => {
        if(user){
            setUser(user)
        }
    }

    const sidebarSwitcher = () => {
        setSidebarCollapse(!sidebarCollapse)
    }

    const handleToken = (token) =>{
        setToken(token)
        localStorage.setItem("RUK_AUTH_TOKEN", token)
    }

    const handleUserSave = (user) =>{
        setUser(user)
        localStorage.setItem("user", JSON.stringify(user))
    }

    const handleLogout = () =>{
        localStorage.removeItem("RUK_AUTH_TOKEN")
        localStorage.removeItem("user")
        localStorage.removeItem("role")
        setToken('')
        setUser({})
    }

   const checkAccess = async () =>{
        let res = await UserAuthService.getAuthUser()
        if(res?.forumId){
            setIsForum(true)
        }
       if(res?.isCoach){
           setIsCoach(true)
       }
       console.log(res, 'accress ress')
    }

    useEffect(()=>{
        checkAccess()
    },[])

    useEffect(()=>{
        checkTheme()
    },[])

    useEffect(()=>{
        checkUser()
    },[user])

    const value={
        firstLogin,
        setFirstLogin,
        theme,
        user,
        setUser,
        setTheme,
        token,
        handleToken,
        handleLogout,
        handleUserSave,
        sidebarSwitcher,
        sidebarCollapse,
        setSidebarCollapse,
        VaultSearch,
        vaultSearch,
        pointUpdate,
        setPointUpdate,
        otpVerified,
        setOtpVerified,
        resetVerified,
        setResetVerified,
        setProfileUpdate,
        profileUpdate,
        setChartUpdate,
        chartUpdate,
        chartSelected,
        setChartSelected,
        chartFilterType,
        setChartFilterType,
        isCoach,
        isForum,
        selectedYear,
        setSelectedYear,
        setVaultSearch
    }

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};